namespace $ {
	export type $shm_hitalama_map_relation_data = {
		id: string
		from: string
		to: string
		kind: string
		owner: string
	}

	export type $shm_hitalama_map_relation_missing_data = {
		id: string
		from: string
		target: string
	}

	export function $shm_hitalama_map_entity_relations_missing(
		map: $shm_hitalama_map,
	): readonly $shm_hitalama_map_relation_missing_data[] {
		const widgets = map.Widgets_list()?.remote_list() ?? []
		const entity_datasets = new Set( widgets.flatMap( widget => {
			if( widget.type() !== 'entity' ) return []
			const dataset = widget.Dataset()?.remote()
			return dataset ? [ dataset.link().str ] : []
		}) )

		return widgets.flatMap( widget => {
			if( widget.type() !== 'entity_field' ) return []
			const field = widget.Entity_field()?.remote()
			if( !field || ( field.type() !== 'atom_link' && field.type() !== 'list_link' ) ) return []
			const target = field.target_dataset()
			if( !target || entity_datasets.has( target.link().str ) ) return []
			return [{
				id: `entity-missing:${ field.link().str }:${ target.link().str }`,
				from: widget.link_str(),
				target: target.link().str,
			}]
		})
	}

	export function $shm_hitalama_map_entity_relations( map: $shm_hitalama_map ): readonly $shm_hitalama_map_relation_data[] {
		const widgets = map.Widgets_list()?.remote_list() ?? []
		const entities = widgets.filter( widget => widget.type() === 'entity' )
		const properties = widgets.filter( widget => widget.type() === 'entity_field' )
		const entity_by_dataset = new Map( entities.flatMap( widget => {
			const dataset = widget.Dataset()?.remote()
			return dataset ? [[ dataset.link().str, widget ] as const] : []
		}) )
		const property_by_field = new Map( properties.flatMap( widget => {
			const field = widget.Entity_field()?.remote()
			return field ? [[ field.link().str, widget ] as const] : []
		}) )
		const result: $shm_hitalama_map_relation_data[] = []

		for( const property of properties ) {
			const field = property.Entity_field()?.remote()
			if( !field || ( field.type() !== 'atom_link' && field.type() !== 'list_link' ) ) continue
			const target = field.target_dataset()
			if( !target ) continue
			const inverse = field.inverse_field()

			if( inverse ) {
				const target_property = property_by_field.get( inverse.link().str )
				if( !target_property ) continue
				if( field.type() === 'list_link' && inverse.type() === 'atom_link' ) continue
				if( field.type() === inverse.type() && field.link().str > inverse.link().str ) continue
				result.push({
					id: `entity-inverse:${ field.link().str }:${ inverse.link().str }`,
					from: property.link_str(),
					to: target_property.link_str(),
					kind: 'entity_inverse',
					owner: 'entity_schema',
				})
				continue
			}

			const target_entity = entity_by_dataset.get( target.link().str )
			if( !target_entity ) continue
			result.push({
				id: `entity-link:${ field.link().str }:${ target.link().str }`,
				from: property.link_str(),
				to: target_entity.link_str(),
				kind: field.type(),
				owner: 'entity_schema',
			})
		}

		return result
	}

	export class $shm_hitalama_map_relation {
		static stored( map: $shm_hitalama_map ): readonly $shm_hitalama_map_relation_data[] {
			return map.store( 'relations' ) ?? []
		}
		static list( map: $shm_hitalama_map ): readonly $shm_hitalama_map_relation_data[] {
			return [ ... this.stored( map ), ... $shm_hitalama_map_entity_relations( map ) ]
		}
		static replace( map: $shm_hitalama_map, owner: string, links: readonly $shm_hitalama_map_relation_data[] ) {
			const stored = this.stored( map )
			const next = [ ...stored.filter( link => link.owner !== owner ), ...links ]
			if( JSON.stringify( stored ) !== JSON.stringify( next ) ) map.store( 'relations', next )
		}
	}
}
